/**
 * Created by ricardocabret on 8/18/16.
 */
angular.module('filePerChapterPlayerProvider.model', [

    //This provider handles all File Per Chapter User Audiobooks (MP3)

])
    .service('FilePerChapterPlayer', ['WS', function (WS) {

        const toSeconds = (time) => {
            return Math.floor(time / 1000);
        };

        this.isSample = false;

        this._getAudiobookPlaybackUrl = function (libraryAudiobookId, chapterId) {
            const requestString = libraryAudiobookId + '/' + chapterId;
            return WS.callServer('download/getAudiobookPlaybackUrl/' + requestString, null);
        };

        this.initPlayer = function (eventCallbacksObj) {
            this._setupFpcPlayer(eventCallbacksObj);
        };

        this._setupFpcPlayer = function (eventCallbacksObj) {
            if (this.fpcPlayer != null && !this.fpcPlayer.paused) {
                this.fpcPlayer.pause();
                this.fpcPlayer.currentTime = 0;
            }
            this.fpcPlayer = new Audio;

            this.fpcPlayer.addEventListener("canplaythrough", () => {
                eventCallbacksObj.handleOnLoad(this.fpcPlayer);
            }, false);

            this.fpcPlayer.addEventListener("timeupdate", () => {
                eventCallbacksObj.handleTimeChanged(this.fpcPlayer.currentTime * 1000)
            }, false);

            this.fpcPlayer.addEventListener('ended', () => {
                eventCallbacksObj.handleOnEnd();
                this.fpcPlayer.currentTime = 0;
            });
        };

        this._loadFpcPlayer = function (url, callbackFunc) {
            if (!this.fpcPlayer) {
                return;
            }
            this.fpcPlayer.src = url;

            if (callbackFunc) {
                callbackFunc();
            }
        };

        this.play = async (libraryAudiobook, isSample, trackObj, position, callbackFunc) => {
            const response = await this._getAudiobookPlaybackUrl(libraryAudiobook.id, trackObj.chapterObj.id);
            if (response && response.responseStatus === 'SUCCESS') {
                this._loadFpcPlayer(response.url, () => {
                    if (callbackFunc) {
                        callbackFunc(response);
                    }

                    this.fpcPlayer.currentTime = toSeconds(position);
                    this.fpcPlayer.play();
                });
            }
        };

        this.getCurrentTime = function () {
            if (!this.fpcPlayer) {
                return;
            }
            return this.fpcPlayer.currentTime * 1000;
        };

        this.resumePlay = function () {
            if (!this.fpcPlayer) {
                return;
            }
            this.fpcPlayer.play();
        };

        this.pause = function () {
            if (!this.fpcPlayer) {
                return;
            }
            this.fpcPlayer.pause();
        };

        this.skipToTrack = function (libraryAudiobook, trackObj, callbackFunc) {
            this.play(libraryAudiobook, null, trackObj, 0, callbackFunc);
        };

        this.seekTo = function (time) {
            if (!this.fpcPlayer) {
                return;
            }
            this.fpcPlayer.currentTime = toSeconds(time);
        };

        this.setVolume = function (value) {
            if (!this.fpcPlayer) {
                return;
            }
            this.fpcPlayer.volume = value / 100;
        };

        this.mutePlayer = function () {
            if (!this.fpcPlayer) {
                return;
            }
            this.fpcPlayer.volume = 0;
        };

    }])
;
